import { Formik, Form } from "formik";
import * as Yup from "yup";

const PopupForm = ({
  isOpen,
  onClose,
  formData,
  handleData,
  loading,
  renderField,
}) => {
  if (!isOpen) return null;

  // Define validation schema
  const validationSchema = Yup.object().shape({
    date: Yup.string().required("Date is required"),
    description: Yup.string().required("Description is required"),
    note: Yup.string().required("Note is required"), // optional
  });

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-4 w-full max-w-md mr-4 ml-4 md:mr-0 md:ml-0">
        <h1 className="text-xl font-medium text-primary mb-2 ">Add Leave</h1>
        <Formik
          initialValues={formData()}
          validationSchema={validationSchema}
          onSubmit={(values) => handleData(values)}
        >
          {({ values, handleChange, handleSubmit, isValid, dirty }) => (
            <Form>
              {Object.keys(values).map((key) =>
                renderField(key, { values, handleChange })
              )}

              <div className="flex justify-end mt-4 gap-2">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-300  rounded-lg hover:bg-gray-400 transition"
                  onClick={onClose}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-green-700 transition disabled:opacity-50"
                  disabled={loading || !isValid || !dirty} //disabled until required fields filled
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default PopupForm;
